import React from "react";
import { useTranslation } from "react-i18next";

import usersService from "../../../../services/userService";

import DropDownMenu from "../../DropDownMenu";
import { Button } from "../../Buttons";

function ParentDropdown({ userInfo }) {
  const { t } = useTranslation();
  return (
    <DropDownMenu>
      <ul>
        <li className="hasBorderBottom">
          <p>{userInfo?.name}</p>
        </li>
        <li>
          <Button
            label={t("editProfile")}
            iconClassName="hasIcon--edit"
            viewType="noBorder"
            onClick={() =>
              usersService.goToMonolith("accounts/users/profile/")
            }
          />
        </li>
        <li>
          <Button
            label={t("billing")}
            iconClassName="hasIcon--credit-card"
            viewType="noBorder"
            onClick={() =>
              usersService.goToMonolith("accounts/payment/")
            }
          />
        </li>
        <li>
          <Button
            label={t("logout")}
            iconClassName="hasIcon--log-out"
            viewType="noBorder"
            onClick={() => usersService.goToMonolith("accounts/logout/?next=/")}
          />
        </li>
      </ul>
    </DropDownMenu>
  );
}

export default ParentDropdown;
